import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { API } from '../../apis/api';
import { connect } from 'react-redux';
import styles from './AggregateSequence.module.css';
import { useHistory, useParams } from 'react-router-dom';
import { FreePoolAgsnModal } from '..';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import resequencingActions from '../../redux/features/resequencing/actions';
import AssignShiftPopup from '../AssignShiftPopup/AssignShiftPopup';
import {
  getAggregatePlanUrl,
  getAggregateReSequenceUrl,
  getDatesForRange,
  setStylesAccordingToPlant,
} from '../../utils/utils';
import { AsnWarningDialog, AttributesSelector } from '../../components';
import {
  buildErrorMessage,
  fetchAggregateFromFreePool,
  fetchSequenceForDatePlantAndLine,
} from '../../apis/calls';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { BackButton } from '../../components';
import SequenceToolbar from '../../components/SequenceToolbar/SequenceToolbar';
import Table from '../../components/Table/Table';
import { withAllowedOperationsProvider } from '../../hocs';
import {
  DATE_FORMAT,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
} from '../../constants';
import { fetchAggregateSequenceForDatePlantAndLine } from '../../apis/calls';
import { processAggregateSequenceData } from '../../utils/tableUtils';
import AgsnWarningDialog from '../AgsnWarningDailog/AgsnWarningDialog';
import { OPTIONAL_ATTRIBUTES } from '../../staticData';

const AggregateSequence = ({
  setHasActiveEdits,
  aggregate,
  setActiveDate,
  activeDate,
  startDate,
  endDate,
}) => {
  const [aggregateLine] = usePlantAndLinesStore().aggregateLineState;
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [dates, setDates] = useState([]);
  const [shopId, setShopId] = useState(null);
  const [selectedOptionalColNames, setSelectedOptionalColNames] = useState([
    OPTIONAL_ATTRIBUTES.FAMILY,
    OPTIONAL_ATTRIBUTES.BUILD_CARD_NUMBER,
    OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME,
    OPTIONAL_ATTRIBUTES.POWER_STEERING,
    OPTIONAL_ATTRIBUTES.COUNTRY,
    OPTIONAL_ATTRIBUTES.MARKET,
  ]);

  const handleShiftAssignment = () => {
    setIsShiftAssignmentPopupOpen(true);
  };
  const [asnData, setAsnData] = useState([]);
  const history = useHistory();
  const { showLoading, showPopup, closePopUp } = usePopupManager();
  const { showInternalError, showSuccess } = usePopupManager();
  const { sequenceDate } = useParams();
  const [isShiftAssignmentPopupOpen, setIsShiftAssignmentPopupOpen] = useState(
    false,
  );
  const [isGenerateAgsn, setIsGenerateAgsn] = useState(false);

  const [activeShifts, setActiveShifts] = useState([]);
  const [sequenceData, setSequenceData] = useState({
    loading: false,
    data: [],
  });
  const [freePoolAggregatesData, setFreePoolAggregatesData] = useState({
    loading: false,
    data: [],
  });
  const params = new URLSearchParams(window.location.search);
  const isPreview = params.get('preview');
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [isFreePoolModalOpen, setIsFreePoolModalOpen] = useState(false);
  const openWarning = () => {
    setIsWarningOpen(true);
  };
  const ROW_HEIGHT = 38;

  const redirectToApplicationLandingPage = () => {
    history.push(getAggregatePlanUrl(aggregate));
  };

  const shiftColumn = {
    width: 100,
    title: 'Shift',
    field: 'shiftName',
    enableSearch: true,
    enableFilter: true,
    render: row => {
      const currentShiftLabel = row.shiftName;
      if (currentShiftLabel)
        return <div className={styles.shift}>{currentShiftLabel}</div>;
      return null;
    },
  };
  const fixedColumns = [
    {
      width: 140,
      title: 'Part No.',
      field: 'materialNumber',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 235,
      title: 'Part Description',
      field: 'materialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'ASN',
      field: 'parentAsn',
      enableSearch: true,
      enableFilter: true,
    },
    shiftColumn,
    {
      width: 235,
      title: 'Destination',
      field: 'destination',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 235,
      title: 'Chassis Line',
      field: 'parentLineName',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 190,
      title: 'VC',
      field: 'parentMaterialNumber',
      enableSearch: true,
      enableFilter: true,
    }, 
  ];
    
  const OptionalColumns = [
    {
      width: 190,
      title: 'VC Description',
      field: 'parentMaterialDescription',
      enableSearch: true,
      enableFilter: true,
    },  
  ]

  useEffect(() => {
    setActiveDate(sequenceDate);
    if (sequenceDate && shopId) {
      loadActiveShiftsForPlantShopLine(
        plant.value,
        shopId,
        aggregateLine.value,
        sequenceDate,
        sequenceDate,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant.value, shopId, aggregateLine.value, activeDate]);

  useEffect(() => {
    setActiveDate(activeDate);
  }, [setActiveDate, activeDate]);

  useEffect(() => {
    const dateRange = getDatesForRange(startDate, endDate);
    setDates(dateRange);
    setActiveDate(activeDate || dateRange[0]);
  }, [startDate, endDate, setActiveDate, activeDate]);

  useEffect(() => {
    activeDate && loadAggregateSequenceDataForDate(activeDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeDate]);

  useEffect(() => {
    sequenceDate && loadAggregateFreePoolData();
    sequenceDate && loadAggregateSequenceDataForDate(sequenceDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceDate, aggregateLine, plant]);

  useEffect(() => {
    if (aggregateLine.value) {
      loadShopIdForSelectedLine(aggregateLine.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregateLine]);

  useEffect(() => {
    if (sequenceData.data.length > 0) {
      const formattedData = sequenceData.data.map(record => ({
        id: record.id,
        asnId: record.asnId,
        status: record.status,
        serialNumber: record.serialNumber,
      }));
      setAsnData(formattedData);
      const shiftAssigned = sequenceData.data.some(record => record.shiftId);
    if (shiftAssigned) {
      setSelectedOptionalColNames(prev => ['Shift', ...prev]);
      setSelectedOptionalColNames(prev => [...prev]);
    } else {
      setIsGenerateAgsn(false);
    }
  } else {
    setIsGenerateAgsn(true);
  }
}, [sequenceData.data]);
  const closeModal = () => setIsFreePoolModalOpen(false);
  const generateAgSN = async () => {
    const dateString = moment(sequenceDate).format(DATE_FORMAT.ISO);
    try {
      showLoading();
      await API.patch(
        API_RESOURCE_URLS.generateAgSN(plant.value, aggregateLine.value),
        {
          date: dateString,
        },
      );
      closePopUp();
      showSuccess({
        contextText: DISPLAY_MESSAGES.GENERATE_AGSN,
        info: '',
      });
      redirectToApplicationLandingPage();
    } catch (err) {
      console.error('Failed to generate AgSN', buildErrorMessage(err));
      showInternalError();
    }
  };

  const loadAggregateSequenceDataForDate = async date => {
    const dateString = moment(date).format(DATE_FORMAT.ISO);
    try {
      setSequenceData(prevState => ({ ...prevState, loading: true }));
      const response = await fetchAggregateSequenceForDatePlantAndLine(
        dateString,
        plant.value,
        aggregateLine.value,
      );
      const processedRows = processAggregateSequenceData(response.data);
      setSequenceData({
        data: processedRows,
        loading: false,
      });
    } catch (err) {
      console.error('failed to load sequence');
      setSequenceData({
        data: [],
        loading: false,
      });
    }
  };

  const loadActiveShiftsForPlantShopLine = async (
    plantId,
    shopId,
    aggregateLineId,
    from,
    to,
  ) => {
    if (!plantId && !shopId && !aggregateLineId && !from && !to) return;
    try {
      const response = await API.get(
        API_RESOURCE_URLS.shiftAssignments(
          plantId,
          shopId,
          aggregateLineId,
          from,
          to,
        ),
      );
      const formattedShifts = response.data.map(record => ({
        value: record.shiftId,
        label: record.shiftName,
        isAvailable: true,
      }));

      const sortedShifts = formattedShifts.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      setActiveShifts(sortedShifts);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setActiveShifts([]);
    }
  };
  const loadShopIdForSelectedLine = async lineId => {
    try {
      const response = await API.get(
        API_RESOURCE_URLS.lineDetailsByLineId(lineId), // TODO: get from planning instead of digital twin service
      );
      const lineDetails = response.data;
      setShopId(lineDetails.shop?.id);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setShopId(null);
    }
  };
  const loadAggregateFreePoolData = async () => {
    try {
      setFreePoolAggregatesData(prevState => ({
        ...prevState,
        loading: true,
      }));
      const response = await fetchAggregateFromFreePool(
        sequenceDate,
        plant.value,
        aggregateLine.value,
      );
      setFreePoolAggregatesData({
        data: response.data,
        loading: false,
      });
      if (response.data.length > 0 && !isPreview) setIsFreePoolModalOpen(true);
    } catch (err) {
      console.error('failed to load freepool aggregates data');
      setSequenceData({
        data: [],
        loading: false,
      });
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        error: err,
      });
    }
  };
  useEffect(() => {
    sequenceDate && loadAggregateFreePoolData();
    sequenceDate && loadAggregateSequenceDataForDate(sequenceDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceDate, aggregateLine, plant]);

  const redirectToResequenceForDate = () => {
    if (window.navigator.onLine)
      history.push(`${getAggregateReSequenceUrl(aggregate)}/${sequenceDate}`);
    else
      window.alert(
        'No internet connection. Pls check your network connection and try again.',
      );
  };
  const getAsnsPayloadWithBulkShiftsAssigned = (
    sortedRequiredShifts,
    requiredAvailableAsns,
    assignmentsToShiftLabelsMap,
  ) => {
    const payloadWithShiftsAssigned = [];

    const requiredAvailableAsnsPayload = requiredAvailableAsns.map(
      ({ id }) => ({ id }),
    );

    for (const shift of sortedRequiredShifts) {
      const asnsWithCurrentShiftAssigned = requiredAvailableAsnsPayload
        .slice(
          payloadWithShiftsAssigned.length,
          payloadWithShiftsAssigned.length +
            assignmentsToShiftLabelsMap[shift.label],
        )
        .map(data => ({ materialId: data.id, shiftId: shift.value }));
      payloadWithShiftsAssigned.push(...asnsWithCurrentShiftAssigned);
    }
    return payloadWithShiftsAssigned;
  };

  const bulkAssignShift = async (
    sortedRequiredShifts,
    requiredAvailableAsns,
    assignmentsToShiftLabelsMap,
  ) => {
    const asnsPayload = getAsnsPayloadWithBulkShiftsAssigned(
      sortedRequiredShifts,
      requiredAvailableAsns,
      assignmentsToShiftLabelsMap,
    );
    try {
      await API.patch(
        API_RESOURCE_URLS.assignShiftToMaterialWhileSequencing(
          plant.value,
          aggregateLine.value,
        ),
        asnsPayload,
        {
          params: {
            date: sequenceDate,
          },
        },
      );
      loadAggregateSequenceDataForDate(sequenceDate);
      setIsGenerateAgsn(true);
    } catch (err) {
      setIsGenerateAgsn(false);
      console.error('failed to assign shift err:' + buildErrorMessage(err));
      showInternalError();
    }
  };

  return (
    <>
      <div className={styles.container}>
        <BackButton
          basePath={aggregate}
          action="Sequence"
          handleClick={redirectToApplicationLandingPage}
        />

        <SequenceToolbar date={sequenceDate} lineName={aggregateLine.label} />

        <div className={styles.tableView}>
          <Table
            columns={[...fixedColumns,...OptionalColumns]}
            defaultColumns={[...fixedColumns]}
            rowHeight={ROW_HEIGHT}
            rows={sequenceData.data}
            setHasActiveEdits={setHasActiveEdits}
            setAsnCount={() => {}}
            hideCheckbox
            primaryAction={{
              name: 'GENERATE AgSN',
              actionFn: selectedRows => openWarning(selectedRows),
              className: styles.generateAgsn,
              shouldEnable: () => isGenerateAgsn,
              authOperation: USER_OPERATIONS.GENERATE_AGSN,
            }}
            secondaryActions={[
              {
                name: 'RESEQUENCE',
                authOperation: USER_OPERATIONS.UPDATE_AGGREGATE_PLAN_SEQUENCE,
                actionFn: () => redirectToResequenceForDate(activeDate),
              },
              {
                name: 'ASSIGN SHIFT',
                actionFn: () => handleShiftAssignment(),
              },
            ]}
          />
        </div>
      </div>
      <FreePoolAgsnModal
        open={isFreePoolModalOpen}
        title="Found Match"
        handleClose={closeModal}
        lineBackgroundColor="#82C1A7"
        handleSubmit={closeModal}
        rowsData={freePoolAggregatesData}
      />
      <AgsnWarningDialog
        open={isWarningOpen}
        handleClose={() => setIsWarningOpen(false)}
        generateAgsn={generateAgSN}
      />
      <AssignShiftPopup
        open={isShiftAssignmentPopupOpen}
        closeForm={() => {
          setIsShiftAssignmentPopupOpen(false);
        }}
        shifts={activeShifts}
        refreshData={() => true}
        bulkAssignShift={bulkAssignShift}
        dateOfAgsns={activeDate}
        totalQuantities={sequenceData.data.length || 0}
        asns={asnData}
      />
    </>
  );
};

AggregateSequence.propTypes = {
  aggregate: PropTypes.string.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  setHasActiveEdits: PropTypes.func.isRequired,
};

const App = connect(
  ({ resequencing }) => ({
    startDate: resequencing.startDate,
    endDate: resequencing.endDate,
    activeDate: resequencing.activeDate,
    isResequencingFlowActive: resequencing.isResequencingFlowActive,
  }),
  {
    setActiveDate: resequencingActions.setActiveDate,
    endResequencingFlow: resequencingActions.endResequencingFlow,
  },
)(AggregateSequence);

export default withAllowedOperationsProvider(App, true, RESOURCE_TYPE.MATERIAL);
